import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, withModifiers as _withModifiers, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "modalOuter"
}
const _hoisted_2 = { class: "modal register" }
const _hoisted_3 = { class: "modalInner" }
const _hoisted_4 = { class: "modalContent" }
const _hoisted_5 = { class: "textarea" }
const _hoisted_6 = {
  key: 0,
  class: "info"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", { class: "red" }, "You’ve completed the game!", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", { class: "dark" }, "But have you topped the leader board?", -1)
const _hoisted_9 = [
  _hoisted_7,
  _hoisted_8
]
const _hoisted_10 = {
  key: 1,
  class: "info"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("p", { class: "red" }, "You’re out of lives :(", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("p", { class: "dark" }, "But you might still top the leader board. ", -1)
const _hoisted_13 = [
  _hoisted_11,
  _hoisted_12
]
const _hoisted_14 = { class: "field" }
const _hoisted_15 = { for: "fullName" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", { class: "text" }, "Leader Board Name:", -1)
const _hoisted_17 = { class: "field" }
const _hoisted_18 = { for: "businessEmail" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", { class: "text" }, "Business Email:", -1)
const _hoisted_20 = { class: "checkbox" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("span", { class: "text" }, "'Opt-in' to keep in the loop and receive future communications from Creative ITC. ", -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("span", { class: "checkmark" }, null, -1)
const _hoisted_23 = { class: "modalFooter" }
const _hoisted_24 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.showModal)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("form", {
                class: "form",
                id: "register-form",
                onSubmit: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitForm && _ctx.submitForm(...args)), ["prevent"]))
              }, [
                _createElementVNode("div", _hoisted_5, [
                  (_ctx.isGameCompleted)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_6, _hoisted_9))
                    : (_openBlock(), _createElementBlock("div", _hoisted_10, _hoisted_13))
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("label", _hoisted_15, [
                    _hoisted_16,
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      id: "leaderBoardName",
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.playerName) = $event)),
                      maxlength: "10",
                      required: ""
                    }, null, 512), [
                      [_vModelText, _ctx.playerName]
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("label", _hoisted_18, [
                    _hoisted_19,
                    _withDirectives(_createElementVNode("input", {
                      type: "email",
                      id: "businessEmail",
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.businessEmail) = $event)),
                      required: ""
                    }, null, 512), [
                      [_vModelText, _ctx.businessEmail]
                    ])
                  ])
                ]),
                _createElementVNode("label", _hoisted_20, [
                  _hoisted_21,
                  _withDirectives(_createElementVNode("input", {
                    type: "checkbox",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.optIn) = $event))
                  }, null, 512), [
                    [_vModelCheckbox, _ctx.optIn]
                  ]),
                  _hoisted_22
                ])
              ], 32)
            ]),
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("button", {
                type: "submit",
                form: "register-form",
                class: "btn btn-large btn-primary",
                disabled: _ctx.loading
              }, _toDisplayString(_ctx.loading ? '...' : 'REGISTER YOUR SCORE'), 9, _hoisted_24)
            ])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}